import { z } from "zod";

// A Season groups episodes inside a series. Bloom v1 expects most shows to
// ship as a single season (seasonNumber = 1) but the hierarchy lets us host
// longer drama runs without a schema change later.
export const seasonSchema = z.object({
  _id: z.string(),
  seriesId: z.string(),
  seasonNumber: z.number().int().positive(),
  titleTh: z.string().optional(),
  titleEn: z.string().optional(),
  synopsisTh: z.string().optional(),
  synopsisEn: z.string().optional(),
  posterUrl: z.string().url().optional(),
  trailerStreamVideoId: z.string().optional(),
  episodeCount: z.number().int().nonnegative().default(0),
  releaseDate: z.coerce.date().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Season = z.infer<typeof seasonSchema>;
